/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { login as loginApi, LoginRequest, LoginResponse } from '@/api/auth';
import { toast } from '@/hooks/use-toast';
import { AUTH_LOCAL_STORAGE_KEYS } from '@/constants/localStorage';

interface UseLoginMutationOptions {
  onSuccess?: (data: LoginResponse) => void;
  onError?: (error: any) => void;
  skipStorage?: boolean; // Option to skip localStorage operations (for custom handling)
}

export function useLoginMutation(options?: UseLoginMutationOptions) {
  return useMutation({
    mutationFn: loginApi,
    onSuccess: (data: LoginResponse) => {
      if (
        data.success &&
        data.data?.access_token &&
        data.data?.session_token &&
        data.data?.user
      ) {
        // Centralized localStorage storage logic
        if (!options?.skipStorage) {
          localStorage.setItem(
            AUTH_LOCAL_STORAGE_KEYS.AUTH_TOKEN,
            data.data.access_token
          );
          localStorage.setItem(
            AUTH_LOCAL_STORAGE_KEYS.LANDING_SESSION_TOKEN,
            data.data.session_token
          );
          localStorage.setItem(
            AUTH_LOCAL_STORAGE_KEYS.USER,
            JSON.stringify(data.data.user)
          );
          localStorage.setItem(
            AUTH_LOCAL_STORAGE_KEYS.TOKEN_EXPIRES_AT,
            data.data.token_expires_at
          );
        }

        toast({
          title: 'Success',
          description: data.message || 'Logged in successfully',
        });
        options?.onSuccess?.(data);
      } else {
        toast({
          title: 'Error',
          description: data.message || 'Login failed',
          variant: 'destructive',
        });
      }
    },
    onError: (error: any) => {
      toast({
        title: 'Error',
        description: error?.response?.data?.message || 'Failed to login',
        variant: 'destructive',
      });
      options?.onError?.(error);
    },
  });
}
